import React from 'react'
import { fragDoc } from '../utils/fragments'
import { mapPolicies,mapPolicyPageData } from '../utils/mapper'
import { withStyles } from '@material-ui/core/styles'

import Banner from '../components/banner'

import Footer from '../components/footer'
import styles from '../styles/site'
import PolicyList from '../components/policy/policyList'

const PoliciesPage = props => {

  const policies = mapPolicies(props.data.policies)
  const policyPageData = mapPolicyPageData(props.data.policiespagesdata)
  return (

<div>

    <Banner
      uid="contact"
      title={policyPageData.title}
      subtitle={policyPageData.subtitle}
      background={policyPageData.image}

    />
    <div style={{marginBottom:'8em'}}>
      {policies.map((policy) => {
        return (
          <PolicyList key={policy.id} title={policy.title.text} summary={policy.text[0].html} uid={policy.uid}/>

        )
      })}
   </div>
<Footer policies={props.data.policiesdata.edges}/>
</div>



  )
}

export default withStyles(styles)(PoliciesPage)

export const query = graphql`
  query policiesQuery($id:String) {


    policiespagesdata: prismicCtArchivePage(uid: { eq: $id }) {


      type
       id
       data {
        title{
          html
          text
        }

        subtitle {
          html
          text
        }

        image {
          url
          localFile {
            childImageSharp {
              original {
                src
              }
              sizes(maxWidth: 640) {
                ...GatsbyImageSharpSizes
              }
            }
          }
        }
      }
      }



    policies: allPrismicCtDoc {
      edges {
        node {
          ...doc
        }
      }
    }

    policiesdata: allPrismicCtDoc {
      edges {
      node {
        uid
        data {
            title {

              text
            }


          }
      }
      }
      }
  }
`



// WEBPACK FOOTER //
// ./src/pages/policies.js